define([
    "jquery",
    "underscore",
    "marionette",
    "views/common/datatables_view"
], function($, _, Marionette, DatatablesView){
    return Marionette.LayoutView.extend({
        el: '#content_layout',

        ui: {
            'datatables': '#datatables'
        },

        initialize: function(){
            this.bindUIElements();

            this.datatablesView = new DatatablesView(
                {
                    datatablesEl: this.ui.datatables,
                    url: '/rest_report/unfunded_accounts',
                    order: [[ 0, "desc" ]],
                    columns: [
                        {
                            'name':'name',
                            'data':'name'
                        },
                        {
                            'name':'reg_datetime',
                            'data':'reg_datetime',
                            'type': 'date'
                        },
                        {
                            'name':'country',
                            'data':'country'
                        },
                        {
                            'name':'email',
                            'data':'email'
                        },
                        {
                            'name':'phone_number',
                            'data':'phone_number'
                        }
                    ]
                }
            );
        }
    });
});
